import type { CreateLocalActionRequest } from "~/pages/administration/workflows-page/workflows-dialog/views/action-view/hooks/use-action-view";

export const hasActionsChanged = (
  original: CreateLocalActionRequest[],
  current: CreateLocalActionRequest[]
) => {
  if (original.length !== current.length) return true;

  // Detect reordering
  for (let i = 0; i < original.length; i++) {
    if (original[i]?.id !== current[i]?.id) return true;
  }

  const changed = original.some((orig) => {
    const curr = current.find((x) => x.id === orig.id);
    if (!curr) return true;
    return (
      orig.name !== curr.name ||
      JSON.stringify(orig.configuration) !== JSON.stringify(curr.configuration) ||
      JSON.stringify(orig.statusCodes ?? []) !== JSON.stringify(curr.statusCodes ?? [])
    );
  });
  if (changed) return true;

  return current.some((curr) => !original.find((x) => x.id === curr.id));
};
